var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7777 6.60303H0.89502C0.61902 6.60303 0.39502 6.37903 0.39502 6.10303C0.39502 5.82703 0.61902 5.60303 0.89502 5.60303H12.7777C13.0537 5.60303 13.2777 5.82703 13.2777 6.10303C13.2777 6.37903 13.0537 6.60303 12.7777 6.60303",
    fill: "#8395A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80101 9.20654C9.52501 9.20654 9.29834 8.98254 9.29834 8.70654C9.29834 8.43054 9.51901 8.20654 9.79501 8.20654H9.80101C10.077 8.20654 10.301 8.43054 10.301 8.70654C10.301 8.98254 10.077 9.20654 9.80101 9.20654",
    fill: "#8395A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84251 9.20654C6.56651 9.20654 6.33984 8.98254 6.33984 8.70654C6.33984 8.43054 6.56051 8.20654 6.83651 8.20654H6.84251C7.11851 8.20654 7.34251 8.43054 7.34251 8.70654C7.34251 8.98254 7.11851 9.20654 6.84251 9.20654",
    fill: "#8395A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.87833 9.20654C3.60233 9.20654 3.375 8.98254 3.375 8.70654C3.375 8.43054 3.59633 8.20654 3.87233 8.20654H3.87833C4.15433 8.20654 4.37833 8.43054 4.37833 8.70654C4.37833 8.98254 4.15433 9.20654 3.87833 9.20654",
    fill: "#8395A7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80101 11.7976C9.52501 11.7976 9.29834 11.5736 9.29834 11.2976C9.29834 11.0216 9.51901 10.7976 9.79501 10.7976H9.80101C10.077 10.7976 10.301 11.0216 10.301 11.2976C10.301 11.5736 10.077 11.7976 9.80101 11.7976",
    fill: "#8395A7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84251 11.7976C6.56651 11.7976 6.33984 11.5736 6.33984 11.2976C6.33984 11.0216 6.56051 10.7976 6.83651 10.7976H6.84251C7.11851 10.7976 7.34251 11.0216 7.34251 11.2976C7.34251 11.5736 7.11851 11.7976 6.84251 11.7976",
    fill: "#8395A7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.87833 11.7976C3.60233 11.7976 3.375 11.5736 3.375 11.2976C3.375 11.0216 3.59633 10.7976 3.87233 10.7976H3.87833C4.15433 10.7976 4.37833 11.0216 4.37833 11.2976C4.37833 11.5736 4.15433 11.7976 3.87833 11.7976",
    fill: "#8395A7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5293 3.86075C9.2533 3.86075 9.0293 3.63675 9.0293 3.36075V1.16675C9.0293 0.890748 9.2533 0.666748 9.5293 0.666748C9.8053 0.666748 10.0293 0.890748 10.0293 1.16675V3.36075C10.0293 3.63675 9.8053 3.86075 9.5293 3.86075",
    fill: "#8395A7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14355 3.86075C3.86755 3.86075 3.64355 3.63675 3.64355 3.36075V1.16675C3.64355 0.890748 3.86755 0.666748 4.14355 0.666748C4.41955 0.666748 4.64355 0.890748 4.64355 1.16675V3.36075C4.64355 3.63675 4.41955 3.86075 4.14355 3.86075",
    fill: "#8395A7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1370_4892",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 14,
    height: 14
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333496 1.71948H13.3335V15.0001H0.333496V1.71948Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1370_4892)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01416 2.71948C2.2855 2.71948 1.3335 3.64148 1.3335 5.31548V11.3481C1.3335 13.0588 2.2855 14.0001 4.01416 14.0001H9.65283C11.3815 14.0001 12.3335 13.0761 12.3335 11.3988V5.31548C12.3362 4.49215 12.1148 3.85215 11.6755 3.41215C11.2235 2.95882 10.5268 2.71948 9.65883 2.71948H4.01416ZM9.65283 15.0001H4.01416C1.74416 15.0001 0.333496 13.6008 0.333496 11.3481V5.31548C0.333496 3.09682 1.74416 1.71948 4.01416 1.71948H9.65883C10.7982 1.71948 11.7402 2.06082 12.3835 2.70548C13.0082 3.33282 13.3368 4.23482 13.3335 5.31682V11.3988C13.3335 13.6201 11.9228 15.0001 9.65283 15.0001V15.0001Z",
    fill: "#8395A7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.72a3b7a6756869ce3449d2d5faab48ef.svg";
export { ForwardRef as ReactComponent };